import ProductsForm from '@app/components/apps/Products/ProductsForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row, Button as BaseButton } from 'antd';
import { useEffect, useState } from 'react';

const routes = [
  {
    path: '/products',
    breadcrumbName: 'Products',
  },
  {
    path: '/add-product',
    breadcrumbName: 'Add Product',
  },
];

const CreateProductPage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ProductsForm
          editable={true}
          pageTitle={'Create Product'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default CreateProductPage;
